import {PaginationQueryParams} from './pagination-query-params';

export interface CatalogsQueryParams extends PaginationQueryParams {
  search?: string;
  unpaginated?: boolean;
}

export type CatalogAssociationQueryParams =
  {product_id: number | string; bundle_id?: never} | {bundle_id: number | string; product_id?: never};

export const DEFAULT_CATALOGS_QUERY_PARAMS: CatalogsQueryParams = {
  page: 1,
  per_page: 10,
};
